import { zodResolver } from '@hookform/resolvers/zod'
import { Accordion, AccordionDetails, AccordionGroup, Grid } from '@mui/joy'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'
import { stringRequiredScheme } from '~/shared/lib/schemas'
import { Button } from '~/shared/ui/Buttons'
import { FormProvider, TextareaInput, TextInput } from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'
import { SolutionFormValues } from './type'

const formSchema = z.object({
  responsibleComment: stringRequiredScheme,
})

type SolutionFormProps = {
  canEdit: boolean
  isSubmitting?: boolean
  isLoading?: boolean
  defaultValues?: Partial<SolutionFormValues>
  onSuccess: (formValues: SolutionFormValues) => void
}

export function SolutionForm({
  canEdit,
  isLoading,
  defaultValues,
  onSuccess,
  isSubmitting,
}: SolutionFormProps) {
  const { t } = useTranslation()
  const [isEditing, setIsEditing] = useState<boolean>(false)
  const disabled = !isEditing || isSubmitting

  const form = useForm<SolutionFormValues>({
    defaultValues,
    resolver: zodResolver(formSchema),
  })
  const { reset } = form

  const handleButtonsShow = () => {
    if (!canEdit) return null
    setIsEditing(true)
  }

  const handleButtonsHidden = () => {
    setIsEditing(false)
  }

  const handleCancel = () => {
    reset()
    handleButtonsHidden()
  }

  useEffect(() => {
    if (defaultValues) form.reset(defaultValues)
    // eslint-disable-next-line
  }, [defaultValues])

  useEffect(() => {
    if (!isSubmitting) handleButtonsHidden()
  }, [isSubmitting])

  return (
    <FormProvider form={form} onSuccess={onSuccess}>
      <Container onDoubleClick={handleButtonsShow}>
        <ContainerTitle>{t('resolution')}</ContainerTitle>
        <Grid container spacing={2.5}>
          <Grid xs={12}>
            <TextInput
              label='form.responsible manager'
              placeholder='form.responsible manager'
              name='responsible'
              readOnly
              skeletonShow={isLoading}
            />
          </Grid>
          <Grid xs={12}>
            <TextareaInput
              label='form.comment'
              name='responsibleComment'
              placeholder='form.enter comment'
              skeletonShow={isLoading}
              readOnly={disabled}
              sx={{
                height: '138px',
              }}
            />
          </Grid>

          <AccordionGroup>
            <Accordion expanded={isEditing} sx={{ minHeight: 0, padding: 0 }}>
              <AccordionDetails>
                <Grid xs={12} direction='row'>
                  <Button
                    variant='green'
                    type='submit'
                    loading={isSubmitting}
                    sx={{ marginRight: '24px' }}
                  >
                    {t('button.save')}
                  </Button>
                  <Button
                    variant='red'
                    onClick={handleCancel}
                    disabled={isSubmitting}
                  >
                    {t('button.cancel')}
                  </Button>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </AccordionGroup>
        </Grid>
      </Container>
    </FormProvider>
  )
}
